import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/var/www/Fixr/frontend/components/layout/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentProvider"] */ "/var/www/Fixr/frontend/components/layout/CookieConsentProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/var/www/Fixr/frontend/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/var/www/Fixr/frontend/components/layout/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/Fixr/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
